import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-white shadow-sm py-4" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-73">
        <div className="flex items-center" data-id="element-74">
          <BrainCircuitIcon className="h-8 w-8 text-orange-600 mr-2" data-id="element-75" />
          <span className="font-bold text-xl text-orange-800" data-id="element-76">
            Info Ecommerce
          </span>
        </div>
        <nav className="hidden md:flex space-x-6" data-id="element-77">
          <a href="#" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-78">
            Inicio
          </a>
          <a href="#objection-handler" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-79">
            Beneficios
          </a>
          <a href="#typeform-embed" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-80">
            Reservar Sesión
          </a>
        </nav>
        <a href="#typeform-embed" className="bg-orange-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-700 transition duration-200 text-sm md:text-base" data-id="element-81">
          Reservar Ahora
        </a>
      </div>
    </header>;
}